// Brand data for Franchise India Knowledge Services

export const brands = [
  {
    name: "ActionCOACH",
    category: "Business Coaching",
    sector: "Coaching, Training & Consulting",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/1thxujfk_1.%20Main-logo-Business-Coaching-Gradient-Icon-Yellow-Black-White%20Background%20%281%29.jpg",
    blurb: "The world's #1 business coaching firm, helping entrepreneurs build profitable, self-managing enterprises.",
  },
  {
    name: "Brian Tracy Solutions",
    category: "Sales & Leadership Training",
    sector: "Coaching, Training & Consulting",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/06857m9y_brian_tracy_solutions_logo.jpeg",
    blurb: "World-renowned personal & professional development programs from author Brian Tracy.",
  },
  {
    name: "Network In Action",
    category: "Business Networking",
    sector: "Franchise & Business Consulting",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/24ptm2qc_NIA_franchiselogo-for-blue-back%20%281%29.png",
    dark: true,
    blurb: "A modern, technology-driven business networking franchise built for meaningful referrals.",
  },
  {
    name: "D32 Business Network",
    category: "Business Networking",
    sector: "Franchise & Business Consulting",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/zk729fjv_D32BN_Logo_Horizontal_Full%20%281%29.webp",
    blurb: "The power of connection — a premium networking community for growth-focused business owners.",
  },
  {
    name: "Mars Venus Coaching",
    category: "Life & Relationship Coaching",
    sector: "Coaching, Training & Consulting",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/frfxcfpn_mars_venus_coaching_logo%20%281%29.jpeg",
    blurb: "Based on John Gray's bestselling work, transforming relationships and workplaces worldwide.",
  },
  {
    name: "Sales Geek",
    category: "Sales Consulting & Training",
    sector: "Coaching, Training & Consulting",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/5sxds2il_black%20logo.png",
    blurb: "Outsourced sales leadership and training that helps businesses sell smarter, not harder.",
  },
  {
    name: "NLP4Kids",
    category: "Child Education",
    sector: "Child Education & Experience",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/m5j1mqtb_logo%20%283%29.png",
    blurb: "Therapeutic coaching helping children and teens build confidence, focus and emotional resilience.",
  },
  {
    name: "Fish n Flips",
    category: "Swim School",
    sector: "Child Experience & Sports",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/2kerb5ux_images%20%2810%29.png",
    blurb: "A joyful, world-class swim school experience teaching water confidence to young learners.",
  },
  {
    name: "Mom In Business",
    category: "Entrepreneurship Community",
    sector: "Franchise & Business Consulting",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/e07z1uou_WhatsApp%20Image%202026-07-07%20at%2012.13.31%20PM.jpeg",
    dark: true,
    blurb: "An international platform empowering women entrepreneurs to launch and scale their ventures.",
  },
  {
    name: "Strike Back",
    category: "Self Defence for Women",
    sector: "Sports Education",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/wxjcqhok_WhatsApp%20Image%202026-06-19%20at%2010.30.58%20AM.jpeg",
    dark: true,
    blurb: "Empowering women through practical self-defence programs and confidence-building workshops.",
  },
  {
    name: "Basketball Training Systems",
    category: "Sports Education",
    sector: "Sports Education",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/4cj9dy21_images%20%2811%29.jpeg",
    blurb: "Structured, coach-led basketball development programs for schools, academies and clubs.",
  },
  {
    name: "Baby Ballers",
    category: "Early Years Sport",
    sector: "Child Experience",
    logo: "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/pu11dk1a_images%20%2811%29.png",
    blurb: "Fun, developmental football sessions building coordination and confidence in young children.",
  },
];

export const sectors = [
  {
    title: "Coaching, Training & Consulting",
    icon: "GraduationCap",
    desc: "Global coaching and professional development franchises.",
  },
  {
    title: "Child Experience & Education",
    icon: "Baby",
    desc: "Enriching learning and experience concepts for children.",
  },
  {
    title: "Franchise & Business Consulting",
    icon: "Network",
    desc: "Networking and business-building franchise systems.",
  },
  {
    title: "Sports Education",
    icon: "Trophy",
    desc: "Skill-based sports and physical development programs.",
  },
];
